import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import GaaFinalPredictorPage from './GaaFinalPredictorPage';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function GaaFinalDemoPage() {
  const { demoId } = useParams();
  const [demoClub, setDemoClub] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/gaa/demo/${demoId}`)
      .then((r) => { if (!cancelled) { setDemoClub(r.data); setLoading(false); } })
      .catch((err) => {
        if (cancelled) return;
        setError(err.response?.data?.detail || 'Demo not found');
        setLoading(false);
      });
    return () => { cancelled = true; };
  }, [demoId]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="animate-pulse text-sm text-gray-400">Loading demo…</div>
      </div>
    );
  }
  if (error || !demoClub) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white px-6">
        <div className="text-center max-w-md">
          <h1 className="text-2xl font-black text-[#1D3557] mb-2">Demo not found</h1>
          <p className="text-sm text-gray-600">{error || 'This All-Ireland Final demo has expired or was never created.'}</p>
          <a href="/" className="inline-block mt-4 text-sm font-bold text-[#E63946] underline">Back to TargetFunder</a>
        </div>
      </div>
    );
  }

  return <GaaFinalPredictorPage demoMode demoClub={demoClub} />;
}
